import React from "react";
import { buildVendorServiceCategoryBadgeRows } from "../utils/vendorServiceCategoryBadges";

/**
 * Shared service-category chips for Chat / discovery vendor cards.
 * Logic lives in vendorServiceCategoryBadges so call sites stay thin.
 */
export default function VendorServiceCategoryBadges({
  serviceCategories,
  highlightedServices,
  serviceColors,
  maxVisible = 5,
  className = "flex flex-wrap gap-1.5 mb-3",
}) {
  const badgeRows = buildVendorServiceCategoryBadgeRows(
    serviceCategories,
    highlightedServices,
    serviceColors
  );
  if (badgeRows.length === 0) return null;

  return (
    <div className={className}>
      {badgeRows.slice(0, maxVisible).map((row, catIdx) => {
        const { displayName, color: colors, isHighlighted } = row;
        const colorStyle =
          typeof colors === "object" && colors?.bgColor
            ? {
                backgroundColor: colors.bgColor,
                color: colors.textColor,
                border: `1px solid ${colors.borderColor}`,
              }
            : {};

        return (
          <span
            key={`${displayName}-${catIdx}`}
            style={isHighlighted ? {} : colorStyle}
            className={`inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium transition-colors ${
              isHighlighted
                ? "bg-purple-100 text-[#6036C4] ring-1 ring-inset ring-[#6036C4]"
                : typeof colors === "object" && colors?.bgColor
                  ? ""
                  : `ring-1 ring-inset ${colors?.bg || ""} ${colors?.text || ""} ${colors?.ring || ""}`
            }`}
          >
            {displayName}
          </span>
        );
      })}
      {badgeRows.length > maxVisible && (
        <span className="inline-flex items-center px-2 py-0.5 text-xs text-gray-500">
          +{badgeRows.length - maxVisible} more
        </span>
      )}
    </div>
  );
}
